import React, { useEffect } from 'react'
import { ControlHighlight } from '@fs/zion-icon'
import { Button, Paragraph, Separator } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { useSlsHighlightsContext, useSlsStateContext } from '@fs/zion-sls'
import PanelHeader from '../shared/PanelHeader'
import HighlightsTips from './HighlightsTips'
import { getFieldValue } from './utils/highlightUtils'
import { useOverlayContext } from '../../../../../shared/providers/overlayContextProvider/OverlayContext'

const HighlightPanelContent = ({ splitScreenImageArk, title }) => {
  const [t] = useTranslation()
  const { highlightsPanelOverlay, topMostPanel } = useOverlayContext()
  const { currentImageArk } = useSlsStateContext()
  const { setCreatingRects, setEditMode, setDisplayHighlights, activeFieldInfo } = useSlsHighlightsContext()

  useEffect(() => {
    if (highlightsPanelOverlay.isOpen && topMostPanel() === 'highlightsPanel') {
      setEditMode(true)

      setDisplayHighlights({
        mainPartitionKey: currentImageArk,
        mainZoomFilter: (highlight) => highlight.attached,
        attachFilter: (highlight) => highlight.fieldId === activeFieldInfo.id,
      })

      if (splitScreenImageArk) {
        setDisplayHighlights({
          splitScreenPartitionKey: splitScreenImageArk,
          splitScreenZoomFilter: (highlight) => highlight.attached,
          attachFilter: (highlight) => highlight.fieldId === activeFieldInfo.id,
        })
      }
    }
  }, [
    highlightsPanelOverlay.isOpen,
    currentImageArk,
    activeFieldInfo?.id,
    topMostPanel,
    splitScreenImageArk,
    setDisplayHighlights,
    setEditMode,
  ])

  const instructions = t('editHighlight.instructions', 'Select the {fieldType} "{fieldValue}".', {
    fieldType: activeFieldInfo?.label || activeFieldInfo?.displayLabel,
    fieldValue: activeFieldInfo?.fieldType === 'EVENT_TYPE' ? '' : getFieldValue({ activeFieldInfo, t }),
  })

  return (
    <>
      <PanelHeader
        heading={title}
        caption={t('editHighlight.panelHeader.panelCaption', 'Select the blue highlights or create your own')}
      />
      <HighlightsTips />
      <Separator size="xs" />
      {/* Remove empty string from displaying */}
      <Paragraph size="sm">{(instructions || '').replace(' "".', '.')}</Paragraph>
      <Separator size="xs" />
      <Button
        Icon={ControlHighlight}
        onClick={() => setCreatingRects(true)}
        data-testid="highlights-panel-new-highlight"
        linkName="Edit Highlights New Highlight"
      >
        {t('editHighlight.highlightTips.newHighlight', 'New Highlight')}
      </Button>
      <Separator size="xs" />
    </>
  )
}

export default HighlightPanelContent
